import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Proposal } from "app/entities/proposal";

@Component({
    selector: 'app-proposal-action-date-dialog',
    templateUrl: './proposal-action-date-dialog.component.html',
    styleUrls: ['./proposal-action-date-dialog.component.scss']
})
export class ProposalActionDateDialogComponent implements OnInit {
    form?: FormGroup;

    constructor(
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: { 
            action: string; 
            label: string; 
            date: Date;
            proposal: Proposal
        },
        private dialogRef: MatDialogRef<ProposalActionDateDialogComponent>
    ) { }

    ngOnInit() {
        this.form = this.fb.group({
            date: [this.data.date, Validators.required],
            reason: ['']
        });
    }

    confirm() {
        if (this.form?.valid) {
            this.dialogRef.close(this.form?.value);
        }
    }
}
